$(document).ready(function () {
	if ($('.modal-installments').length > 0) {

		$('#open-modal-credit-js').click(function (e) {
			e.preventDefault();
			dropModalInstallments();
			$('.modal-installments-js').css('display', 'block');
			$('.good-item__properties').css('display', 'block');
			$('.modal-installments-js').addClass('opened');
			$('body').css('overflow', 'hidden');
		});

		$('.installments-close-js').click(function (e) {
			e.preventDefault();
			onDropModalInstallments();
			$('.modal-installments-js').attr('style', 'display: none;');
			$('.good-item__properties').css('display', 'flex');

			$('.modal-installments-js').removeClass('opened');
			$('.modal-installments-js').removeClass('success');

			let name = $('#installments-form-name');
			let phone = $('#installments-form-phone');
			let check = $('#form-confirm-installments');

			name.val('').closest('.installments-form__input ').removeClass('k1-error');
			phone.val('').closest('.installments-form__input ').removeClass('k1-error');
			check.prop('checked', false).closest('.confirm__wrap').find('label').removeClass('k1-error');
			$('body').attr('style', '');

			$('.modal-installments__inner').addClass('active');
			$('.modal-installments__success').removeClass('active');
		});

		$('.modal-installments form').submit(function (e) {
			e.preventDefault();
			let err = false;
			let name = $('#installments-form-name');
			let phone = $('#installments-form-phone');
			let check = $('#form-confirm-installments');

			if (name.val().length < 2) {
				name.closest('.installments-form__input ').addClass('k1-error');
				err = true;
			} else {
				name.closest('.installments-form__input ').removeClass('k1-error');
			}

			if (!window.k1Forms.validatePhone('installments-form-phone')) {
				phone.closest('.installments-form__input ').addClass('k1-error');
				err = true;
			} else {
				phone.closest('.installments-form__input ').removeClass('k1-error');
			}

			if (!document.querySelector('#form-confirm-installments').checked) {
				check.closest('.confirm__wrap').find('label').addClass('k1-error');
				err = true
			} else {
				check.closest('.confirm__wrap').find('label').removeClass('k1-error');
			};

			if (err) return false;

			let data = {
				"name": name.val(),
				"phone": phone.val(),
				"productID": $('.k1-sku-block-js').attr('data-current-sku'),
				"productName": $('.installments-item__name').text(),
				"currentSKU": $('.good-element__sku-title').text(),
				"price": $('.good-element__price-current').text()
			}
			if ($('.installments-item__discount').length > 0) {
				data.discount = $('.installments-item__discount').text();
			}
			if ($('.installments-item__discount').length > 0) {
				data.priceOld = $('.installments-item .product-item-detail-price-old').text();
			}


			grecaptcha.ready(() => {
				grecaptcha.execute(document.querySelector('meta[name="google-recaptcha"]').content, {
					action: 'fast_order_installments'
				})
				.then((token) => {
					data.recaptcha = token;

					$.ajax({
						type: "POST",
						url: window.location.origin + "/ajax/installments_form.php",
						data: data,
						dataType: "json",
						success: function (response) {
							if (response.status === true) {
								$('.modal-installments__inner').removeClass('active');
								$('.modal-installments-js').addClass('success');
								ym(9755971,'reachGoal','oformite-v-rassrochku');
								$('.modal-installments__success').addClass('active');
							setTimeout(() => {
							  // Код для задержки на 5 секунд
								$('.modal-installments-js').removeClass('success');
								$('.modal-installments__success').removeClass('active');
								$('.modal-installments-js ').removeClass('opened');
								$('body').css('overflow','visible');
								$('.modal.modal-installments-js').css('display','none');

							}, 5000);
							}
						}
					});
				})
			})
		});
	}

	$(document).click(function (e) {
		if ($(e.target).hasClass('modal__bg'))
			if ($(e.target).find('.installments-close-js'))
				$('.installments-close-js').click();
	});
});

function dropModalInstallments() {
	let sky = $('.good-element__sku');
	let price = $('.good-element__price-box');

	$('.installments-item').append(sky);
	$('.installments-item').append(price);
}

function onDropModalInstallments() {
	let sky = $('.good-element__sku');
	let price = $('.good-element__price-box');

	$('.good-element__price').after(sky);
	$('.good-element__price').prepend(price);
	price.find('.good-element__price-current').attr('style', '');
}
